<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i> 角色管理</el-breadcrumb-item>
                <el-breadcrumb-item>职能管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
<!--        <div class="container" style="min-width: 900px" v-show="showList">
            <div class="handle-box">

                <el-select v-model="query.projectName" placeholder="项目名称" @change="current($event)"  class="handle-select mr10">
                    <el-option value="" label="所有项目"></el-option>
                    <el-option v-for="item in this.query.curProjects" :key="item.objectId" :value="item.cnName" :label="item.name"></el-option>
                </el-select>

                <el-input v-model="query.nickName" placeholder="Filter" @keyup.enter.native="handleSearch" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："nickname"、"Id"</span> 
            </div>

            <div class="hovertable">
                <el-table
                :data="roleTbale.perTableData"
                class="table"
                v-loading="roleTbale.loading"
                ref="multipleTable"
                :cell-style="{ textAlign: 'center'}"
                :header-cell-style="{textAlign: 'center'}"
                header-cell-class-name="table-header"
                @row-click="rowClick"
                >   
                    <el-table-column prop="userId" label="ID" align="center"></el-table-column>
                    <el-table-column prop="nickName" label="Nickname"></el-table-column>
                    <el-table-column prop="roleId" label="RoleId"></el-table-column>
                    <el-table-column prop="projectId" label="Project">
                        <template slot-scope="{ row }">
                            <el-badge :value="row.projectNum" style="margin-top: 9px" type="primary">
                                <el-popover
                                    placement="right-start"
                                    title="全部项目"
                                    width="300"
                                    trigger="hover"
                                    :content=row.projectList>
                                        <el-button slot="reference">{{row.projectId}}</el-button>
                                </el-popover>
                            </el-badge>
                        </template> 
                    </el-table-column>
                    <el-table-column prop="loginTime" label="LoginTime" :formatter="dateFormat">
                        <template slot-scope="scope">
                            <span v-if="scope.row.loginTime == undefined">暂未登陆</span>
                            <span v-if="scope.row.loginTime != undefined">
                                {{dateFormat(scope.row, scope.column)}}
                            </span>
                        </template> 
                    </el-table-column>
                </el-table>
            </div>
            
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="roleTbale.pageIndex"
                    :page-size="roleTbale.pageSize"
                    :total="roleTbale.pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>-->
        <!-- -------------------------------------------------------- 职位详细 页面 ----------------------------------------------------- -->
        <div class="container container-content" v-show="showContent">
            <el-page-header @back="goBack" content="详情页面"></el-page-header>
            <el-divider></el-divider>

            <el-row :gutter="20" style="margin-left: 27px">
                <el-col :span="8">
                    <div class="grid-content"> 
                        <p>Nickname</p>
                        <p class="cont">{{nickName}}</p>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <p>上次登录</p>
                        <p class="cont">{{this.loginTime}}</p>
                    </div>
                </el-col>
                <el-col :span="4">
                        <el-button type="primary" style="margin-top: 5%" @click="submit()">储存更新</el-button>
                        <el-button type="primary" style="margin-top: 5%" @click="initPassword()">初始化密码</el-button>
                </el-col>
            </el-row>

<!--            <el-divider content-position="left"><h3 style="color: #303133">项目所属</h3></el-divider>
            <div class="plugins-tips">
                <el-checkbox-group v-model="checkedAllCities">
                    <el-checkbox label="All" @change="checkedAllFun">All</el-checkbox>
                </el-checkbox-group>
            </div>

            &lt;!&ndash; :class  all按钮选中后, 禁用此Div &ndash;&gt;
            <div class="drag-box" v-loading = "divLoading" element-loading-spinner="el-icon-lock">
                <div class="drag-box-item">
                    <div class="item-title">项目</div>
                    
                    <div group="site">
                        <div tag="div" id="projects" class="item-ul">
                            <el-table
                            style="width: 100%"
                            height="400"
                            :data="drag.projects"
                            stripe
                            v-loading="roleLoading"
                            @selection-change="left_handleSelectionChange"
                            @row-click="left_rowClick"
                            >
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="cnName" label="全选"></el-table-column>
                                <el-table-column prop="handle" width="65">
                                    <template slot="header" label="111">
                                        <div @click="left_selectionClick" style="font-size: 22px; cursor: pointer; color: #606266; width: 100%; text-align: center;">
                                            <i class="el-icon-right" style="width: 13px"/>
                                            &lt;!&ndash; <i class="el-icon-d-arrow-right" style="border-bottom: 1px solid #606366"/> &ndash;&gt;
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="drag-box-item">
                    <div class="item-title">所属</div>

                    <div group="site">
                        <div tag="div" id="done" class="item-ul">
                            <el-table
                            ref="singleTable"
                            style="width: 100%"
                            :data="drag.done"
                            height="400"
                            stripe
                            v-loading="roleLoading"
                            empty-text = "未分配"
                            @selection-change="right_handleSelectionChange"
                            @row-click="right_rowClick"
                            highlight-current-row
                            :row-class-name="tableRowClassName"
                            @cell-click="right_cellClick"
                            >
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="cnName" label="全选"></el-table-column>
                                <el-table-column prop="name" width="55" label="" >
                                    <template slot="header" label="111">
                                        <div @click="right_selectionClick" style="font-size: 22px; cursor: pointer; color: #606266; width: 100%; text-align: center; margin-right: 25px">
                                            <i class="el-icon-back" style=" width: 13px;"/>
                                            &lt;!&ndash; <i class="el-icon-d-arrow-left" style="border-bottom: 1px solid #606366"/> &ndash;&gt;
                                        </div>
                                    </template>
                                    <template slot-scope="">
                                        <i class="el-icon-arrow-left" style="font-size: 15px"></i>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <el-divider content-position="left">
                <h3 style="color: #303133">职 位 </h3>
            </el-divider>
            <el-row :gutter="20">
                <el-col :span="20">
                    <div class="grid-content grid-content-posi">
                        <el-checkbox-group
                            v-model="checkedCities"
                            @change="checkBox($event)">
                            <el-checkbox v-for="city in cities" :label="city.roleId" :key="city.roleId" :disabled="disabledStores.includes(city.roleId)">{{city.roleName}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-col>
            </el-row>

            <el-divider content-position="left"><h3 style="color: #303133">权 限</h3></el-divider>
            
            <el-row :gutter="20">
                <el-col :span="10">
                    <div class="grid-content-perm">
                        <ul>
                            <li v-for="item in permission" :key="item">{{item}}</li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="grid-content-perm">
                    
                    </div>
                </el-col>
            </el-row>-->

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import http from '../../common/Common.vue';
import draggable from 'vuedraggable';
import { Post } from '@/service/request/server';

export default {
    name: 'basetable',
    data() {
        return {
            query: {
                nickName: '',  //搜索框值
                projectName: '', //下拉框
                curProjects: []    //下拉框项目集合
            },

            tableData: [], //el-table持久集合
            //职能管理 Table
            roleTbale: {
                perTableData: [], //el-table展示数据
                pageIndex: 1,  //当前页码
                pageSize: 15,  //单页数据量
                pageTotal: 0,  //总数据量
                loading: true,
            },


            roleLoading: true,  //详情table列表
            divLoading: false, //详情项目Div

            //第一列信息
            nickName: '',
            userId: '',
            loginTime: '',
            //展示职位列表
            showList: true,
            //展示职位详细
            showContent: false,

            //所属项目
            drag: {
                //项目缓存
                project: '',
                //项目栏
                projects: [],
                //所属栏
                done:[],
                activeNum: 0, //点击 class样式


                left_multipleSelection: [],  //多选操作
                right_multipleSelection: [],  //多选操作
            },
            //left_项目  全部, all
            checkedAll: false,
            //用于 选中 checkedAll 后,
            disableFlag: false,
            //checkedAll 集合
            checkedAllCities: [],

            //待修改信息
            toRoleInfo: [],
            
            //职位多选框
            cities: [],
            disabledStores: [],
            //多选数据 缓存
            checkedCities: [],
            //多选数据 持久化
            checkedList: [],

            //权限所有信息
            permissionInfo: [],
            //拥有的权限
            permissionId: [],
            //过滤后
            permission: []
        };
    },
    created() {
        this.getProjectName()   //项目所属
        setTimeout(() =>{
            this.getCities()    //职位
        }, 300);
        setTimeout(() =>{
            this.getData(1, undefined, undefined)    //职位
        }, 300);
        setTimeout(() =>{
            this.getPermissionInfo() //权限信息
        }, 300);
        
    },
    mounted() {
        
    },
    activated() {
        this.getData(1, undefined, undefined)
    },
    components: {
        draggable
    },
    methods: {

        //项目所属
        //项目信息
        getProjectName () {
            axios.post(http.httpUrl + 'getAntiProjectDataName').then((res) =>{
                this.drag.projects = res.data
                this.query.curProjects = JSON.parse(JSON.stringify(this.drag.projects))

            }).catch(err =>{
                this.$message.error('获取项目名称失败')
            })
        },

        //获取所有数据
        getData () {
            // operartion:  1.查询未分配职位人员、、2.按项目查询所有人员、3.按账号查询所有已分配职位人员
            // condition:   条件为 账号
            //查询全部
            this.roleTbale.loading = true
            let data = {'startPage': 0, 'pageCount': 9999, 'operation': 4, 'condition': '1'}
            axios.post(http.httpUrlRegAndLogin + 'selInnerMemberByCondition', data).then((res) => {
                this.tableData = res.data.data
                //将roleId 数组 替换为 中文显示 //遍历tableData
                let roleName = []

                this.tableData.forEach((item, index) => {
                    this.$set(item, 'projectList', '')  //该用户所有项目
                    this.$set(item, 'projectNum', 0) //该用户 下 项目总数
                    
                    //遍历table.roleId
                    JSON.parse(item.roleId).forEach(roleId => {

                        //遍历 cities Role中文名
                        this.cities.forEach(roleInfo => {
                            //遍历RoleId, 将roleId 变成 中文
                            if (roleId == roleInfo.roleId) {
                                roleName = roleName.concat(roleInfo.roleName + '\u3000')
                            }
                        })

                        //超级管理员  隐藏
                        if (roleId == 'all') {
                            delete this.tableData[index]
                        }
                        //项目管理员  排在前面
                        if (roleId == '8f0ab88a9f5811ec9b5652540055af6b') { 
                            delete this.tableData[index]
                            this.tableData.push(item)
                        }
                    })
                    
                    //将roleId中文  赋到  roleId ID
                    item.roleId = roleName
                    roleName = []

                    //将projectId 替换 projectName
                    for (let i = 0; i < this.query.curProjects.length; i++) {
                        if (item.projectId == this.query.curProjects[i].objectId) {
                            item.projectId = this.query.curProjects[i].cnName
                        }
                        if (item.projectId == 'all') item.projectId = '所有项目'
                    }
                })

                //project列 悬浮显示该 所有项目
                this.tableData.forEach(item => {
                    let num = 0
                    //
                    this.tableData.forEach(item2 => {
                        if (item.userId == item2.userId) {
                            item.projectNum = ++ num
                            item.projectList = item.projectList.concat(item2.projectId + ' ,\u3000 ')
                        }
                    })
                    //如果projectId == '所有项目'  展示所有 
                    if (item.projectId == '所有项目') {
                        for (let i = 1; i < this.query.curProjects.length; i++) {
                            item.projectNum = ++ num
                            item.projectList = item.projectList.concat(this.query.curProjects[i].cnName + ' ,\u3000 ')
                        }
                    }
                })

                //数据去重
                this.tableData = this.unique(this.tableData)
                //数据倒叙展示
                this.tableData = this.tableData.reverse() 

                this.roleTbale.perTableData = this.tableData
                //总数据量
                this.roleTbale.pageTotal = this.tableData.length
                //分页
                this.pageData()
            })
        },

        //对象数组去重
        unique(arr) {
            const res = new Map();
            return arr.filter((arr) => !res.has(arr.userId) && res.set(arr.userId, 1))
        },

        //分页数据
        pageData(projectName, nickName) {
            this.roleTbale.loading = true
            this.roleTbale.perTableData = []
            let seTableData = this.tableData

            //projectName不为空， 添加项目筛选条件
            if (projectName != undefined && projectName != '') {
                seTableData = seTableData.filter((item) => {
                    return item.projectList.indexOf(projectName) != -1 
                })
            }
            
            //nickName不为空， 添加搜索条件
            if (nickName != undefined && nickName != '') {
                seTableData = seTableData.filter((item) => {
                    return item.userId.indexOf(nickName) != -1 || item.nickName.indexOf(nickName) != -1
                })
            }
            
            //数据分页
            for(let i = this.roleTbale.pageSize * (this.roleTbale.pageIndex - 1) ; i < this.roleTbale.pageSize * this.roleTbale.pageIndex; i++) {
                if (seTableData[i] != undefined) {
                    this.roleTbale.perTableData = this.roleTbale.perTableData.concat(seTableData[i])
                }
            }
            this.roleTbale.pageTotal = seTableData.length
            this.roleTbale.loading = false
        },

        //下拉框动作
        current (projectName) {
            this.query.projectName = projectName
            this.pageData(this.query.projectName, this.query.nickName)
        },

        //搜索框
        handleSearch() {
            this.pageData(this.query.projectName, this.query.nickName)
        },

        //el-Tbale 显示时间格式
        dateFormat (row, column) {
            let date = row[column.property]
            if (date == undefined) return ''
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

        // 分页导航
        handlePageChange (val) {
            this.roleTbale.pageIndex = val
            this.pageData(this.query.projectName, this.query.nickName)
        },

        //row行 点击事件
        rowClick (row, column) {
            this.getProjectName()   //项目所属
            this.drag.done = []    
            this.showList = false
            this.showContent = true
            this.nickName = row.nickName
            this.userId = row.userId
            this.loginTime = moment(row.loginTime).format("YYYY-MM-DD HH:mm:ss")
            
            //初始化修改页面信息 
            this.checkedList = []
            this.checkedAllCities = []
            this.checkedAll = false
            this.checkedAllFunContent()
            this.initRoleInfo ()
        },

        // ---------------------------------------------------  职位 页面  ----------------------------------------------------
        initRoleInfo () {
            //清空 临时存储
            this.checkedCities = []

            let data = {'userId': this.userId}
            axios.post(http.httpUrlRegAndLogin + 'getRoleProjectByUserId', data, {
                headers: {
                    'token': localStorage.getItem('token')
                }
            }).then(res => {
                this.toRoleInfo = res.data.data
                
                this.toRoleInfo.forEach(project => {

                    //如果projectId == all， 代表所有项目
                    if (project.projectId == 'all') {
                        
                        //项目栏 移动到 所属栏
                        this.drag.done = this.drag.projects
                        //删除项目栏重复数据
                        this.drag.projects = []

                        //遍历所属框集合
                        this.drag.done.forEach((item, index) => {
                            
                            //给对应项目多选框赋值
                            this.checkedCities = JSON.parse(project.roleId)
                            //将 临时存储  转移到  持久化list
                            this.checkedList[item.objectId] = this.checkedCities
                            //清空 临时存储
                            this.checkedCities = []
                            
                        })
                        // 禁用项目 所属 框
                        this.checkedAllCities = ['All']
                        this.checkedAll = true
                        this.checkedAllFunContent()
                        //初始化时就选中职位
                        this.checkedCities = this.checkedList[this.drag.done[1].objectId]
                        //刷新权限信息
                        this.fliterPermissionInfo(this.drag.done[1].objectId)

                    } else {
                        //遍历项目集合
                        this.drag.projects.forEach((item, index) => {
                            
                            //将用户所属项目, 移动到所属框
                            if (project.projectId == item.objectId) {
                                //项目栏 移动到 所属栏
                                this.drag.done = this.drag.done.concat(item)
                                //删除项目栏重复数据
                                this.drag.projects.splice(index, 1)
                            }

                            //给对应项目多选框赋值
                            this.checkedCities = JSON.parse(project.roleId)
                            //将 临时存储  转移到  持久化list
                            this.checkedList[project.projectId] = this.checkedCities
                            //清空 临时存储
                            this.checkedCities = []
                        })
                        //初始化页面未选中项目， 无权限
                        this.permission = ['无权限']
                    }
                    this.roleLoading = false
                })
            })
        },

        //选中 All
        checkedAllFun() {
            this.checkedAll = !this.checkedAll
            this.checkedAllFunContent()
        },
        // this.checkedAll 事件变化
        checkedAllFunContent() {
            //默认 项目所属 div可选
            this.divLoading = false
            if (this.checkedAll == true) this.divLoading = true

            //All被选中,  禁用 项目所属 div
            this.disableFlag = false
            if (this.checkedAll == true) this.disableFlag = true

            //解禁职位多选框
            this.disabledStores = []
            //如取消选中, 就禁用多选职位框
            if (this.checkedAll == false) {
                //禁用所有多选框,  选择项目信息后解禁
                for (let i = 0; i < this.cities.length; i++) {
                    this.disabledStores.push(this.cities[i].roleId)
                }
            }
        },

        //左 项目框 多选操作
        left_handleSelectionChange(val) {
            this.drag.left_multipleSelection = val
        },

        //左 项目框 row点击事件
        left_rowClick (row) {
            for (let i = 0; i < this.drag.projects.length; i++) {
                if (row.objectId == this.drag.projects[i].objectId) {
                    this.drag.done = this.drag.done.concat(this.drag.projects[i])
                    this.drag.projects.splice(i, 1)
                }
            }
        },

        //左 项目框多选 赋值到 所属框
        left_selectionClick () {
            
            for (let i = 0; i < this.drag.projects.length; i++) {
                for (let j = 0; j < this.drag.left_multipleSelection.length; j++) {
                    if (this.drag.projects[i].objectId == this.drag.left_multipleSelection[j].objectId) {
                        this.drag.done = this.drag.done.concat(this.drag.projects[i])
                        this.drag.projects.splice(i, 1)
                        
                    }
                }
            }
            this.drag.left_multipleSelection = []
            //禁用所有多选框,  选择项目后解禁
            for (let i = 0; i < this.cities.length; i++) {
                this.disabledStores.push(this.cities[i].roleId)
            }
        },
        
        //右 所属框 cell点击事件,  
        right_cellClick (row, column) {
            this.tableRowIndex = row.index
            if (column.label == '') {
                for (let i = 0; i < this.drag.done.length; i++) {
                    if (row.objectId == this.drag.done[i].objectId) {
                        this.drag.projects = this.drag.projects.concat(this.drag.done[i])
                        //清除已选职位缓存
                        this.checkedList[this.drag.done[i].objectId] = ['7d3b5b1d9f5811ec9b5652540055af6b']

                        this.drag.done.splice(i, 1)
                    }
                }
            }
            //禁用所有多选框,  选择项目后解禁
            for (let i = 0; i < this.cities.length; i++) {
                this.disabledStores.push(this.cities[i].roleId)
            }
        },
        
        //右 所属框多选 赋值到 项目框
        right_selectionClick () {
            for (let i = 0; i < this.drag.done.length; i++) {
                for (let j = 0; j < this.drag.right_multipleSelection.length; j++) {
                    if (this.drag.done[i].objectId == this.drag.right_multipleSelection[j].objectId) {
                        this.drag.projects = this.drag.projects.concat(this.drag.done[i])
                        //清除已选职位缓存
                        this.checkedList[this.drag.done[i].objectId] = ['7d3b5b1d9f5811ec9b5652540055af6b']

                        this.drag.done.splice(i, 1)
                    }
                }
            }
            //清空
            this.drag.right_multipleSelection = []
            //禁用所有多选框,  选择项目后解禁
            for (let i = 0; i < this.cities.length; i++) {
                this.disabledStores.push(this.cities[i].roleId)
            }
        },

        //右 所属框 多选操作
        right_handleSelectionChange(val) {
            this.$refs.singleTable.setCurrentRow();

            this.drag.right_multipleSelection = val

            this.drag.project = val.objectId    //将当前点击的project保存  
            //持久化数据不为空
            if (undefined !== this.checkedList[val.objectId]) {
                
                //清空临时数据
                this.checkedCities = []
                //临时数据  >>>   持久化数据
                this.checkedCities = this.checkedList[val.objectId]
                
            } else {
                this.checkedCities = ['7d3b5b1d9f5811ec9b5652540055af6b']
            }
            //点击选择项目后，解禁职位多选框
            this.disabledStores = []
            
            //刷新权限信息
            this.fliterPermissionInfo(this.drag.project)
        },

        //点击 所属框 的项目
        right_rowClick(row) {
            this.drag.activeNum = row.objectId    //动态切换点击样式
            this.drag.project = row.objectId    //将当前点击的project保存  

            //持久化数据不为空
            if (undefined !== this.checkedList[row.objectId]) {
                //清空临时数据
                this.checkedCities = []
                //临时数据  >>>   持久化数据
                this.checkedCities = this.checkedList[row.objectId]
                
            } else {
                this.checkedCities = ['7d3b5b1d9f5811ec9b5652540055af6b']
            }
            //点击选择项目后，解禁职位多选框
            this.disabledStores = []
            //刷新权限信息
            this.fliterPermissionInfo(this.drag.project)
        },

        //
        tableRowClassName({row, rowIndex}) {
            row.index = rowIndex
        },
        

        //查询所有职位
        getCities() {
            axios.post(http.httpUrlRegAndLogin + 'getAllRolesInfo', null).then(res => {
                let data = res.data
                if (data.code == 200) {
                    //将项目管理员 放在第一位
                    this.cities = data.data

                    this.cities.forEach((item, index) => {
                        if (item.roleName == '项目管理员') {
                            this.cities.splice(index, 1)
                            this.cities.push(item)
                        }
                    });

                    this.cities = this.cities.reverse() //数据倒叙展示
                    this.delCites('92977b059f5811ec9b5652540055af6b')  //删除超级管理员
                } else {
                    this.$message.error(data.message)
                }
                //this.checkedCities = ['7d3b5b1d9f5811ec9b5652540055af6b'] //默认选中未分配

                //禁用所有多选框,  选择项目信息后解禁
                for (let i = 0; i < this.cities.length; i++) {
                    this.disabledStores.push(this.cities[i].roleId)
                }
            })
        },
        //选中职位动作
        checkBox(event) {
            let toRoleId = '7d3b5b1d9f5811ec9b5652540055af6b' //未分配
            this.disabledStores = []    //解禁 未分配

            // 美术·程序·策划·运营...   如选择了其一， 将未分配禁用
            for (let i = 0; i < event.length; i++) {
                //如果选中的是 未分配, 将其他选中 变成 未选中
                if (event[event.length - 1] == toRoleId) {
                    this.checkedCities = []
                    this.checkedCities = [toRoleId]

                } else {
                    //否则, 将未分配 变成 未选中
                    for (let i = 0; i < this.cities.length; i++) {
                        if (this.cities[i].roleId == toRoleId) {
                            //因 未分配 与 其他选项 共选, 将 未分配 变为未选中
                            this.delCheckedCities(toRoleId)
                        }
                    }
                }
            }
            //所有选择框为空时, 选中 未分配
            if (0 == event.length) {
                this.checkedCities = [toRoleId]
            }
            
            //多选框 被选中, 选择职位 作用于多选框
            if (this.drag.right_multipleSelection.length != 0) {
                for(let i = 0; i < this.drag.right_multipleSelection.length; i++) {
                    this.checkedList[this.drag.right_multipleSelection[i].objectId] = this.checkedCities;
                }
            } else {
                //选择职位 作用于被选中
                //将 key: Project, val: 多选集合   存入
                this.checkedList[this.drag.project] = this.checkedCities;
            }

            //刷新权限信息
            this.fliterPermissionInfo(this.drag.project)
        },

        //删除临时岗位岗位
        delCheckedCities(roleId) {
            for (let i = 0; i < this.checkedCities.length; i++) {
                if (this.checkedCities[i] == roleId) {
                    this.checkedCities.splice(i, 1)
                }
            }
        },
        //删除岗位
        delCites(roleId) {
            for (let i = 0; i < this.cities.length; i++) {
                if (this.cities[i].roleId == roleId) {
                    this.cities.splice(i, 1)
                }
            }
        },

        //获取所有权限信息
        getPermissionInfo() {
            axios.post(http.httpUrlRegAndLogin + 'getAllPermissionsInfo', null).then(res => {
                let data = res.data
                if (data.code == 200) {
                    this.permissionInfo = data.data 
                } else {
                    this.$message.error(data.message)
                }
            })
        },

        //过滤显示权限信息
        fliterPermissionInfo(objectId) {
            if (undefined == this.checkedList[objectId] || '7d3b5b1d9f5811ec9b5652540055af6b' == this.checkedList[objectId]) {
                this.permissionId = []
                this.permission = ['无权限']
                return false
            }
            //所拥有的权限, 合并 去重
            var arr = []
            this.checkedList[objectId].forEach((item, index) => {
                //筛选对应权限信息
                let data = {'id': 0, 'permissionId': '', 'roleId': item}
                
                axios.post(http.httpUrlRegAndLogin + 'selRolePermissionByRoleId', data).then(res => {
                    if (res.data.code == 200) {
                        arr = arr.concat(JSON.parse(res.data.data.permissionId))
                        this.permissionId = [...new Set(arr)];
                        this.fliterPermissionInfo2()
                    }
                })
            });
            
        },
        fliterPermissionInfo2() {
            //过滤为 应显示的数据
            this.permission = []
            this.permissionInfo.forEach(info => {
                for (let i = 0; i < this.permissionId.length; i++) {
                    let infoId = this.permissionId[i]
                    
                    if (info.id == infoId) {
                        this.permission = this.permission.concat(info.name)
                    }
                }
            })
        },

        //保存信息
        submit () {
            //checkedList   未选择职位, 排除掉
            var res = []
            //选中 All
            if (true == this.checkedAll) {
                this.checkedCities.splice(0, 1)
                res = res.concat({'projectId': 'all', 'roleId': this.checkedCities})
            } else {
                
                //所属框 验证 未选择职位过滤掉
                this.drag.done.forEach((item, index) => {
                    //职位选择不能为空
                    if (undefined !== this.checkedList[item.objectId]) {
                        //职位选择不为  未分配
                        if ('7d3b5b1d9f5811ec9b5652540055af6b' != this.checkedList[item.objectId]) {

                            res = res.concat({"projectId": item.objectId, "roleId": this.checkedList[item.objectId]})
                        } else {
                            //如为 未分配, 过滤掉当前所属 项目
                            this.drag.done.splice(index, 1)
                        }
                    }
                })
            }

            //未分配
            if (this.drag.done.length == 0) {
                res = res.concat({'projectId': '', 'roleId': this.checkedCities })
            }

            //将选中 all 恢复为默认
            this.checkedAll = false
            
            let data = { 'userId': this.userId, 'data': res }
            axios.post(http.httpUrlRegAndLogin + 'modifyRoleProjectInfo', data,{
                headers: {
                    'token': localStorage.getItem('token') + ''
                },
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    //请求成功
                    this.getData(1, undefined, undefined)
                    //禁用所有多选框,  选择项目信息后解禁
                    for (let i = 0; i < this.cities.length; i++) {
                        this.disabledStores.push(this.cities[i].roleId)
                    }
                    
                    //回到用户列表页
                    this.showContent = false
                    this.showList = true
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },

        //初始化密码
        initPassword() {
            // 二次确认
            this.$confirm('确定要初始化 '+ this.nickName +' 的密码？', '提示', {
                type: 'warning'
            }).then(() => {
                let data = {'id': this.userId}
                //axios.post('http://127.0.0.1:8080/cotton/userAdminInitPassword', data,{
                Post(http.httpUrlRegAndLogin + 'userAdminInitPassword', data,{
                    headers: {
                        'token': localStorage.getItem('token') + ''
                    },
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message)
                    }
                })
            })
        },

        goBack() {
            this.showList = true
            this.showContent = false
        },
    }
};
</script>

<style scoped lang="scss">
/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
//  background-color: #212e3e !important;
    cursor: pointer;
}

::v-deep.el-table__body tr.current-row > td {
    background-color: #79BBFF !important;
}

::v-deep .el-table .success-row {
    background: #79BBFF;
}
// ------------------------------------- 布局 Begin

// //table行内 复制按钮 隐藏
// .copy-roleUserId {
//     display: none;
// }
// //table行 悬浮状态显示 复制按钮
// .el-table__body tr:hover {
//     .copy-roleUserId {
//         display: inline;
//     }
// }

/* el-divider 修改高度&虚线效果 */
.el-divider--horizontal{
    margin: 30px 0;
    &:nth-child(2) {
        margin: 20px 0;
    }
} 
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-col {
    border-radius: 4px;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
    p {
        line-height: 28px;
        font-size: 14px;
        color: #303133;
    }
    .cont {
        letter-spacing: 1px;
    }
}
//拖拽框 点击样式 
.active {
    border: 1px solid #20a0ff !important;
}

//职位多选框
.grid-content-posi {
    margin-left: 6%;
    .el-radio {
        margin: 0 35px;
        line-height: 30px;
    }
}

//权限
.grid-content-perm {
    font-size: 14px;
    padding: 10px 15px;
    margin-left: 40px;
    line-height: 25px;
    color: #303133;
    min-height: 200px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
// ------------------------------------- 布局 End 
.plugins-tips {
    margin-left: 35px;
    padding-left: 30px;
}

.drag-box{
    display: flex;
    user-select: none;
    margin-left: 35px;
}
.drag-box-item {
    flex: 1;
    max-width: 330px;
    min-width: 300px;
    background-color: #eff1f5;
    margin-right: 16px;
    border-radius: 6px;
    border: 1px #e1e4e8 solid;
}
.item-title{
    padding: 8px 8px 8px 12px;
    font-size: 14px;
    line-height: 1.5;
    color: #24292e;
    font-weight: 600;
}
.item-ul{
    padding: 0 8px 8px;
    height: 400px;
    overflow-y: scroll;
}
.item-ul::-webkit-scrollbar{
    width: 0;
}
.drag-list {
    border: 1px #e1e4e8 solid;
    padding: 10px;
    margin: 5px 0 10px;
    font-size: 14px;
    color: #606266;
    list-style: none;
    background-color: #fff;
    border-radius: 6px;
    cursor: pointer;
    -webkit-transition: border .3s ease-in;
    transition: border .3s ease-in;
}
.drag-list:hover {
    border: 1px solid #20a0ff;
}
.drag-title {
    font-weight: 400;
    line-height: 25px;
    margin: 10px 0;
    font-size: 22px;
    color: #1f2f3d;
}
.ghost-style{
    display: block;
    color: transparent;
    border-style: dashed
}
//-------------------------------------- Drag End
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
    border-radius: 5px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
